
import '../_scss/global.scss';
import '../_scss/vendor.scss';

import { UI } from './ui';

import './index';

UI.init();
UI.nav.bind('nav-top', 'menu-item-has-children');
UI.gallery.bind();

window.addEventListener('resize', () => { UI.init() } );